<template>
  <section class="list-students">
    <v-row class="mb-2">
      <v-col cols="12" class="filter-button">
        <unenroll-button :selected="selected" />
        <v-select
          class="filter mr-3"
          v-model="filter"
          :items="filterOptions"
          label="Filter by type"
          hide-details
        />
        <v-select
          class="filter completed-lesson-filter mr-3"
          v-model="lessonsFilter"
          :items="lessonsFilterOptions"
          attach
          chips
          :label="`Students who have completed ${lessonTerm}s`"
          multiple
          hide-details
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption"
              >(+{{ lessonsFilter.length - 1 }} others)</span
            >
          </template>
        </v-select>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search student code"
          hide-details
        />
      </v-col>
      <v-col cols="12">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :headers-length="headers.length + 1"
          hide-default-header
          :items="studentInvitations"
          :search="search"
          hide-default-footer
          :loading="loading"
          :options.sync="pagination"
          flat
          @page-count="pageCount = $event"
        >
          <template v-slot:no-data>
            <p class="mb-0 text-center">
              Loading, please wait
            </p>
          </template>
          <template v-slot:no-results>
            <p class="mb-0 text-center">
              No students in selection
            </p>
          </template>
          <template
            v-slot:header="{ props: { headers, someItems, everyItem }, on }"
          >
            <thead class="v-data-table-header">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="someItems"
                    :indeterminate="someItems && !everyItem"
                    color="primary"
                    hide-details
                    class="pa-0 ma-0"
                    @click.stop="
                      on['toggle-select-all'](
                        (!everItem && !someItems) || !everyItem ? true : false
                      )
                    "
                  />
                </th>
                <th
                  v-for="header in headers"
                  :key="header.text"
                  :class="['column text-center', sortIcon(header)]"
                  @click="changeSort(header.value)"
                >
                  <v-icon
                    v-if="
                      header.sortable &&
                        pagination.sortBy.includes(header.value)
                    "
                    small
                    class="v-data-table-header__icon"
                  >
                    arrow_upward
                  </v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items, isSelected, select }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.id"
                :active="isSelected(item)"
              >
                <td>
                  <v-checkbox
                    color="primary"
                    :input-value="isSelected(item)"
                    primary
                    hide-details
                    class="pa-0 ma-0"
                    @click.stop="select(item, !isSelected(item))"
                  ></v-checkbox>
                </td>
                <td class="text-center">
                  {{ item.invitation_code }}
                </td>
                <td class="text-center">
                  <span
                    :class="[
                      'invitation',
                      item.accepted_at ? 'accepted' : 'notaccepted'
                    ]"
                  ></span>
                </td>
                <td class="text-center">
                  {{
                    item.currently_working_lessons
                      ? item.currently_working_lessons
                      : 'none'
                  }}
                </td>
                <td class="text-center">
                  {{ item.completed_lessons }}
                </td>
                <td class="text-center">
                  <v-btn
                    :disabled="!item.student_id"
                    text
                    color="primary"
                    @click="showStudentDetails(item)"
                  >
                    edit or view results
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <div v-show="pageCount > 1" class="text-center pt-2">
          <v-pagination
            v-model="pagination.page"
            :length="pageCount"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <manage-student
      ref="manageStudent"
      :class-invitation-id.sync="classInvitationId"
      :current-class-id.sync="currentClassId"
      :student-id.sync="studentId"
    />
  </section>
</template>

<script>
import { focus } from 'vue-focus'
import { mapGetters, mapState } from 'vuex'
import UnenrollButton from './student_list/UnenrollButton'
import ManageStudent from '@/modules/student/views/manage_student/ManageStudent'
import ClassInvitation from '@/modules/class/models/ClassInvitation'
import Lesson from '@/modules/lesson/models/Lesson'

export default {
  name: 'StudentList',
  components: {
    UnenrollButton,
    ManageStudent
  },
  directives: { focus: focus },
  props: {
    customClass: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      classInvitationId: null,
      pageCount: 0,
      studentId: null,
      deleteStudentsConfirmation: false,
      courses: [],
      course: null,
      lessonsFilter: [],
      loading: false,
      // lessonsFilterOptions: [],
      // lesson: null,
      pagination: {
        itemsPerPage: 10,
        sortBy: ['invitation_code'],
        sortDesc: [true]
      },
      dropdown_icon: [{ text: 'All' }, { text: 'View unenrolled students' }],
      filter: 'all',
      filterOptions: [
        { text: '- All -', value: 'all' },
        { text: 'Students who accepted invites', value: 'accepted' },
        {
          text: "Students who haven't accepted invites",
          value: 'not-accepted'
        },
        {
          text: "Students who haven't completed all lessons",
          value: 'not-completed'
        }
      ],
      selected: [],
      search: ''
    }
  },
  async mounted() {
    this.$store.state.loading = true
    this.loading = true
    await ClassInvitation.dispatch('getClassInvitations', {
      classId: this.currentClassId
    })
    this.loadQuery()
    this.$store.state.loading = false
    this.loading = false
  },
  computed: {
    ...mapState(['lessonTerm']),
    ...mapGetters('entities/classes', ['currentClassId']),
    headers() {
      return [
        {
          text: 'Student Code',
          align: 'center',
          value: 'invitation_code',
          sortable: true
        },
        {
          text: 'Accepted invitation',
          align: 'center',
          value: 'invitation',
          sortable: true,
          filterable: false
        },
        {
          text: 'Currectly working on',
          align: 'center',
          value: 'current',
          sortable: true
        },
        {
          text: `Completed ${this.capitalizeFirstLetter(this.lessonTerm)}`,
          align: 'center',
          value: 'worksho[',
          sortable: true
        },
        { text: '', value: '', sortable: false, filterable: false }
      ]
    },
    sortIcon() {
      return header => {
        let classes = ''
        if (header.sortable && this.pagination.sortBy.includes(header.value)) {
          classes += 'sortable active'
          if (this.pagination.sortDesc[0]) {
            classes += ' desc'
          } else {
            classes += ' asc'
          }
        }
        return classes
      }
    },
    studentInvitations() {
      let q = ClassInvitation.query()
        .with('student')
        .where('custom_class_id', this.currentClassId)

      if (this.filter === 'accepted') {
        q.where(record => record.accepted_at !== null)
      } else if (this.filter === 'not-accepted') {
        q.where('accepted_at', null)
      }

      if (this.lessonsFilter.length > 0) {
        for (let i = 0; i < this.lessonsFilter.length; i++) {
          let lessonName = this.lessonsFilter[i]
          if (i === 0) {
            if (lessonName === `- No ${this.lessonTerm}s completed -`) {
              q.where(record => record.completed_lessons_name.length === 0)
            } else {
              q.where(record =>
                record.completed_lessons_name.includes(lessonName)
              )
            }
          } else {
            if (lessonName === `- No ${this.lessonTerm}s completed -`) {
              q.orWhere(record => record.completed_lessons_name.length === 0)
            } else {
              q.orWhere(record =>
                record.completed_lessons_name.includes(lessonName)
              )
            }
          }
        }
      }
      // for (let i = 0; i < this.lessonsFilter.length; i++) {
      //   let lessonName = this.lessonsFilter[i]
      //   console.log(lessonName === `- No ${this.lessonTerm}s completed -`)
      //   if (lessonName === `- No ${this.lessonTerm}s completed -`) {
      //     q.where(record => record.completed_lessons_name.length === 0)
      //     console.log(q)
      //   }
      //   if (i > 0) {
      //     q.orWhere(record =>
      //       record.completed_lessons_name.includes(lessonName)
      //     )
      //   } else {
      //     q.where(record =>
      //       record.completed_lessons_name.includes(lessonName)
      //     )
      //   }
      // }

      return q.get()
    },
    lessons() {
      return Lesson.all()
    },
    lessonsFilterOptions() {
      let filterOptions = []
      filterOptions.push(`- No ${this.lessonTerm}s completed -`)
      if (!this.customClass.lessons) return []
      for (let i = 0; i < this.customClass.lessons.length; i++) {
        let lesson = this.customClass.lessons[i]
        filterOptions.push(lesson.name)
      }
      return filterOptions
    }
  },
  methods: {
    studentName(classInvitation) {
      return classInvitation.student && classInvitation.student.name
        ? classInvitation.student.name
        : classInvitation.name
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else {
        this.selected = this.studentInvitations.slice()
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy.includes(column)) {
        this.pagination.sortDesc[0] = !this.pagination.sortDesc[0]
      } else {
        this.pagination.sortBy = [column]
        this.pagination.sortDesc[0] = false
      }
    },
    async showStudentDetails(classInvitation) {
      this.$store.state.loading = true
      this.studentId = classInvitation.student_id
      this.classInvitationId = classInvitation.id
      await this.$nextTick(async () => {
        await this.$refs.manageStudent.initialise()
        this.$store.state.loading = false
        this.$refs.manageStudent.drawer = true
      })
    },
    setQuery() {
      let query = Object.assign({}, this.$route.query)
      query.studentId = this.studentId
      query.classInvitationId = this.classInvitationId
      // if (this.showStudentInfo) {

      // } else {
      //   delete query.studentId
      //   delete query.classInvitationId
      // }
      this.$router.push({ query: query })
    },
    loadQuery() {
      let query = this.$route.query
      if (query.studentId) {
        let invitation = this.studentInvitations.filter(
          val => val.student_id === query.studentId
        )
        if (invitation.length) {
          this.showStudentDetails(invitation[0])
        }
      }
      if (query.uncompletedLesson) {
        if (this.lessonsFilterOptions.length > 0) {
          for (let i = 0; i < this.lessonsFilterOptions.length; i++) {
            if (this.lessonsFilterOptions[i] !== query.uncompletedLesson) {
              this.lessonsFilter.push(this.lessonsFilterOptions[i])
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.list-students {
  min-height: 350px;

  .v-datatable__actions__range-controls {
    display: none !important;
  }

  .invitation {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: block;
    margin: 0 auto;
    border: 1px solid #ddd;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.6);

    &.accepted {
      background: #ccff90;
    }

    &.notaccepted {
      background: #e53935;
    }
  }

  .search-filter {
    padding: 0;
    margin-top: -6px;
  }

  .filter-button {
    > * {
      display: inline-flex;
    }

    .filter {
      max-width: 250px;
      &.completed-lesson-filter {
        max-width: 360px;
        width: 100%;
      }
    }
  }
}
</style>
